import React, { useEffect, useState } from 'react'
import { handleTestimonial } from '../LayoutFunction'
import { NOTEBOOKURL } from '../Config'
import profile1 from "../Assets/avatar.png"
import profile2 from "../Assets/man.png"
import profile3 from "../Assets/woman.png"
import PageTitleBanner from './Common/PageTitleBanner'


const Testimonial = () => {
  const [imageArray, setImageArray] = useState([profile1, profile2, profile3])
  const [data, setData] = useState([])
  const [mainData, setMainData] = useState([])
  const [pageIndex, setpageIndex] = useState(0)
  console.log(mainData.length)
  useEffect(() => {
    getTestimonialData()
  }, [])

  const getTestimonialData = async () => {
    const res = await fetch(`${NOTEBOOKURL}Testimonial/GetTestimonial`, {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        "TestimonialID": "",
        "StartDate": "",
        "EndDate": "",
        "PaginationID": "-1",
        "PageLength": ""
      })
    })
    const result = await res.json()
    console.log(result, "result")
    const tempt = result.data.slice(0, 6)
    setData(tempt)
    setMainData(result.data)
  }
  const handleNextData = (id) => {

    if ((id) * 6 >= mainData.length) {
      return
    }
    let tempt = [...mainData]
    let slicedArray = tempt.slice(id * 6, id * 6 + 6)

    setData(slicedArray)
    setpageIndex(prev => prev + 1)

  }
  const handlepreviousData = (id) => {
    if (id == -1) {
      return
    }

    let tempt = [...mainData]
    let slicedArray = tempt.slice(id * 6, id * 6 + 6)
    setData(slicedArray)
    setpageIndex(prev => prev - 1)

  }
  return (
    <>
      <PageTitleBanner title={"Testimonial"} />
      <div id="content" className="site-content">
        {/* testimonial style-1*/}
        <div className="faq-top secpadd">
          <div className="container">
            <div className="fp-testimonials-grid ">
              <div className="testi-list row">
                {data?.map((item, index) => (
                  <div key={index} className="testi-item col-md-4">
                    <div className="testi-des">{item.Description}<i className="factory-text" /></div>
                    <div className="testi-info clearfix">
                      <img src={imageArray[parseInt(Math.random() * 3)]} alt width={80} height={80} />
                      <h4 className="testi-name"></h4>
                      <span className="testi-job">- {item.Name}</span>
                    </div>
                  </div>
                ))}
              </div>
              {data?.length > 0 && (
                <>
                  <button onClick={() => handlepreviousData(pageIndex - 1)} className='fp-btn-2nd readmore'>PREVIOUS</button>
                  <button onClick={() => handleNextData(pageIndex + 1)} style={{ float: "right" }} className='fp-btn-2nd readmore'>NEXT</button>
                </>
              )}
            </div>
          </div>
        </div>

      </div>
    </>




  )
}

export default Testimonial